import "./App.css";
import Routes from "./Routes/router";
import { BrowserRouter } from "react-router-dom";
import React, { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import axios from "axios";
import apiUrl from "../src/components/helpers/endpointservice";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { logoutFunction, Loader } from "./components/custom/CommonFunction";
import { useCookies, CookiesProvider } from "react-cookie";

function App() {
  const [isLoader, setisLoader] = useState(false);
  const [value, setValue] = useState(false);
  const [decodedData, setDecodedData] = useState({});
  const [dataCode, setDataCode] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies("");

  const handleSignInButtonClick = () => {
    localStorage.setItem("userCheck", "true");
    const redirectUri = process.env.REACT_APP_REDIRECTURI;
    const clientId = process.env.REACT_APP_CLIENTID;
    const scope = process.env.REACT_APP_SCOPE;
    const accesstype = process.env.REACT_APP_ACCESS_TYPE;
    const prompt = process.env.REACT_APP_PROMPT;
    const authUrl =
      process.env.REACT_APP_AUTHURL +
      `?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&access_type=${accesstype}&prompt=${"none"}`;
    window.location.href = authUrl;
  };

  const handleRefreshTokenCookie = async (token) => {
    const tokenUrl = process.env.REACT_APP_GOOGLETOKEN;
    const requestBody = {
      refresh_token: token,
      client_id: process.env.REACT_APP_CLIENTID,
      client_secret: process.env.REACT_APP_CLIENTSECRET,
      grant_type: "refresh_token",
    };
    try {
      const response = await fetch(tokenUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(requestBody),
      });
      if (response.ok) {
        const { id_token } = await response.json();
        const accessToken = id_token;
        let obj = {
          refresh_token: token,
          id_token: id_token,
        };
        localStorage.setItem("userData", JSON.stringify(obj));
        axios.defaults.headers.common["Authorization"] = `Bearer ${id_token}`;
        const decodedToken = jwtDecode(accessToken);
        setDecodedData(decodedToken);
        localStorage.setItem("userDataDecode", JSON.stringify(decodedToken));
        let expiresDateStart = Math.round(
          new Date(
            new Date().setMinutes(new Date().getMinutes() + 56)
          ).getTime() / 1000
        );
        let expiresDateEnd = Math.round(
          new Date(
            new Date().setMinutes(new Date().getMinutes() + 57)
          ).getTime() / 1000
        );
        localStorage.setItem("expiresAtStart", expiresDateStart);
        localStorage.setItem("expiresAtEnd", expiresDateEnd);
        localStorage.removeItem("userexpires");
        axios
          .put(
            apiUrl.TokenAuthenticate +
              "?token=" +
              id_token +
              "&user_email=" +
              decodedToken?.email +
              "&applicationName=" +
              encodeURIComponent("Global Admin")
          )
          .then((response) => {
            if (response?.status === 200) {
              axios
                .get(apiUrl.GetUsers, {
                  headers: { Authorization: "Bearer " + id_token },
                })
                .then((response) => {
                  if (response?.status === 200) {
                    if (response.data?.length > 0) {
                      let email = JSON.parse(
                        localStorage.getItem("userDataDecode")
                      )?.email;
                      var data = response?.data?.filter((r) => r.name == email);
                      localStorage.setItem("userId", data[0]?.id);

                      axios
                        .put(
                          apiUrl.ActionUser + "/" + data[0]?.id + "/lastlogin",
                          "",
                          {
                            headers: {
                              Authorization: "Bearer " + accessToken,
                            },
                          }
                        )
                        .then((response) => {
                          if (response?.status === 200) {
                            setValue(true);
                          } else {
                            setValue(true);
                          }
                          setisLoader(false);
                        })
                        .catch((error) => {
                          setisLoader(false);
                          if (
                            error?.response?.status === 403 ||
                            error?.response?.status === 401
                          ) {
                            setValue(true);
                            // logoutFunction(error?.response?.status)
                          } else {
                            setValue(true);
                          }
                        });

                      axios
                        .get(
                          apiUrl.ActionUser +
                            "/" +
                            data[0]?.id +
                            "/verifyadmin",
                          {
                            headers: {
                              Authorization: "Bearer " + accessToken,
                            },
                          }
                        )
                        .then((response) => {
                          if (response?.status === 200) {
                            localStorage.setItem("isAdmin", "true");
                          } else {
                            localStorage.setItem("isAdmin", "false");
                          }
                        })
                        .catch((error) => {
                          setValue(true);
                          localStorage.setItem("isAdmin", "false");
                          // logoutFunction(error?.response?.status)
                        });
                    }
                  }
                })
                .catch((error) => {
                  setValue(true);
                  // logoutFunction(error?.response?.status)
                });
            } else {
              setisLoader(false);
            }
          })
          .catch((error) => {
            setisLoader(false);
            setValue(true);
            // logoutFunction(error?.response?.status)
          });
      } else {
        console.error("Failed to refresh access token:", response.status);
      }
    } catch (error) {
      localStorage.clear();
      const cookieOptions = {
        domain: process.env.REACT_APP_COMMON_DOMAIN,
        path: "/",
      };
      removeCookie("refreshTokenAC", cookieOptions);
      const redirectUri = process.env.REACT_APP_REDIRECTURI;
      const clientId = process.env.REACT_APP_CLIENTID;
      const scope = process.env.REACT_APP_SCOPE;
      const accesstype = process.env.REACT_APP_ACCESS_TYPE;
      const prompt = process.env.REACT_APP_PROMPT;
      const authUrl =
        process.env.REACT_APP_AUTHURL +
        `?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&access_type=${accesstype}&prompt=${"consent"}`;
      window.location.href = authUrl;
      console.error("Failed to refresh access token:", error);
      console.error("Failed to refresh access token:", error);
    }
  };

  const handleRefreshToken = async () => {
    const tokenUrl = process.env.REACT_APP_GOOGLETOKEN;
    const requestBody = {
      refresh_token:
        JSON.parse(localStorage.getItem("userData"))?.refresh_token ??
        cookies?.refreshTokenAC,
      client_id: process.env.REACT_APP_CLIENTID,
      client_secret: process.env.REACT_APP_CLIENTSECRET,
      grant_type: "refresh_token",
    };

    try {
      const response = await fetch(tokenUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(requestBody),
      });
      if (response.ok) {
        const { id_token } = await response.json();
        const retrievedString = localStorage.getItem("userData");
        const parsedObject = JSON.parse(retrievedString);
        parsedObject.id_token = id_token;
        const updateUser = JSON.stringify(parsedObject);
        localStorage.setItem("userData", updateUser);
        axios.defaults.headers.common["Authorization"] = `Bearer ${id_token}`;
        let expiresDateStart = Math.round(
          new Date(
            new Date().setMinutes(new Date().getMinutes() + 56)
          ).getTime() / 1000
        );
        let expiresDateEnd = Math.round(
          new Date(
            new Date().setMinutes(new Date().getMinutes() + 57)
          ).getTime() / 1000
        );
        localStorage.setItem("expiresAtStart", expiresDateStart);
        localStorage.setItem("expiresAtEnd", expiresDateEnd);
        localStorage.removeItem("userexpires");
        let email = JSON.parse(localStorage.getItem("userDataDecode"))?.email;
        axios
          .put(
            apiUrl.TokenAuthenticate +
              "?token=" +
              id_token +
              "&user_email=" +
              email +
              "&applicationName=" +
              encodeURIComponent("Global Admin")
          )
          .then((response) => {
            if (response?.status === 200) {
            }
          })
          .catch((error) => {
            setisLoader(false);
            logoutFunction(error?.response?.status);
          });
      } else {
        console.error("Failed to refresh access token:", response.status);
      }
    } catch (error) {
      console.error("Failed to refresh access token:", error);
    }
  };

  useEffect(() => {
    const token = cookies?.refreshTokenAC;
    if (token && token !== "undefined" && token !== "null") {
      handleRefreshTokenCookie(cookies?.refreshTokenAC);
      // setValue(true);
    } else {
      if (
        localStorage.getItem("userClick") == "true" &&
        JSON.parse(localStorage.getItem("userData"))?.id_token == undefined &&
        localStorage.getItem("userCheck") != "true"
      ) {
        localStorage.clear();
      }
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      if (localStorage.getItem("userClick") != "true" && code == null) {
        localStorage.setItem("userClick", "true");
        document.getElementById("container")?.click();
      } else {
        if (
          code == null &&
          JSON.parse(localStorage.getItem("userData"))?.id_token === undefined
        ) {
          const redirectUri = process.env.REACT_APP_REDIRECTURI;
          const clientId = process.env.REACT_APP_CLIENTID;
          const scope = process.env.REACT_APP_SCOPE;
          const accesstype = process.env.REACT_APP_ACCESS_TYPE;
          const prompt = process.env.REACT_APP_PROMPT;
          const authUrl =
            process.env.REACT_APP_AUTHURL +
            `?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&access_type=${accesstype}&prompt=${"consent"}`;
          window.location.href = authUrl;
        } else {
          setisLoader(true);
          if (code) {
            setDataCode(code);
            const data = {
              code: code,
              client_id: process.env.REACT_APP_CLIENTID,
              client_secret: process.env.REACT_APP_CLIENTSECRET,
              redirect_uri: process.env.REACT_APP_REDIRECTURI,
              grant_type: process.env.REACT_APP_GRANTTYPE,
            };
            getToken(data);
          }
          // setisLoader(false)
        }
      }
    }

    setInterval(() => {
      let datetime = Math.round(new Date().getTime() / 1000);
      if (localStorage.getItem("userData") != undefined) {
        if (
          localStorage.getItem("userexpires") == undefined &&
          localStorage.getItem("expiresAtStart") < datetime &&
          localStorage.getItem("expiresAtEnd") > datetime
        ) {
          localStorage.setItem("userexpires", "true");
          handleRefreshToken();
        }
      }
    }, 100);

    if (
      JSON.parse(localStorage.getItem("userData"))?.id_token != null &&
      JSON.parse(localStorage.getItem("userData"))?.id_token != undefined
    ) {
      setValue(true);
      setisLoader(false);
    }
  }, []);

  const getToken = (data) => {
    if (data?.code != null) {
      fetch(process.env.REACT_APP_GOOGLETOKEN, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(data),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data?.id_token != undefined) {
            const accessToken = data.id_token;
            localStorage.setItem("userData", JSON.stringify(data));
            const decodedToken = jwtDecode(accessToken);
            setDecodedData(decodedToken);
            const cookieOptions = {
              domain: process.env.REACT_APP_COMMON_DOMAIN,
              path: "/",
            };
            setCookie("refreshTokenAC", data?.refresh_token, cookieOptions);
            axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${data?.id_token}`;
            axios
              .put(
                apiUrl.TokenAuthenticate +
                  "?token=" +
                  data.id_token +
                  "&user_email=" +
                  decodedToken?.email +
                  "&applicationName=" +
                  encodeURIComponent("Global Admin")
              )
              .then((response) => {
                if (response?.status === 200) {
                  axios
                    .get(apiUrl.GetUsers, {
                      headers: { Authorization: "Bearer " + accessToken },
                    })
                    .then((response) => {
                      if (response?.status === 200) {
                        if (response.data?.length > 0) {
                          let email = JSON.parse(
                            localStorage.getItem("userDataDecode")
                          )?.email;
                          var data = response?.data?.filter(
                            (r) => r.name == email
                          );
                          localStorage.setItem("userId", data[0]?.id);

                          axios
                            .put(
                              apiUrl.ActionUser +
                                "/" +
                                data[0]?.id +
                                "/lastlogin",
                              "",
                              {
                                headers: {
                                  Authorization: "Bearer " + accessToken,
                                },
                              }
                            )
                            .then((response) => {
                              if (response?.status === 200) {
                                setValue(true);
                              } else {
                                setValue(true);
                              }
                              setisLoader(false);
                            })
                            .catch((error) => {
                              setisLoader(false);
                              if (
                                error?.response?.status === 403 ||
                                error?.response?.status === 401
                              ) {
                                setValue(true);
                                // logoutFunction(error?.response?.status)
                              } else {
                                setValue(true);
                              }
                            });

                          axios
                            .get(
                              apiUrl.ActionUser +
                                "/" +
                                data[0]?.id +
                                "/verifyadmin",
                              {
                                headers: {
                                  Authorization: "Bearer " + accessToken,
                                },
                              }
                            )
                            .then((response) => {
                              if (response?.status === 200) {
                                localStorage.setItem("isAdmin", "true");
                              } else {
                                localStorage.setItem("isAdmin", "false");
                              }
                            })
                            .catch((error) => {
                              setValue(true);
                              localStorage.setItem("isAdmin", "false");
                              // logoutFunction(error?.response?.status)
                            });
                        }
                      }
                    })
                    .catch((error) => {
                      setValue(true);
                      // logoutFunction(error?.response?.status)
                    });
                } else {
                  setisLoader(false);
                }
              })
              .catch((error) => {
                setisLoader(false);
                setValue(true);
                // logoutFunction(error?.response?.status)
              });
            localStorage.setItem(
              "userDataDecode",
              JSON.stringify(decodedToken)
            );
            let expiresDateStart = Math.round(
              new Date(
                new Date().setMinutes(new Date().getMinutes() + 56)
              ).getTime() / 1000
            );
            let expiresDateEnd = Math.round(
              new Date(
                new Date().setMinutes(new Date().getMinutes() + 57)
              ).getTime() / 1000
            );
            localStorage.setItem("expiresAtStart", expiresDateStart);
            localStorage.setItem("expiresAtEnd", expiresDateEnd);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setisLoader(false);
          logoutFunction(error?.response?.status);
        });
    }
  };

  return (
    <>
      {value == false && (
        <button
          onClick={handleSignInButtonClick}
          className="d-none"
          id="container"
        >
          Sign in with Google
        </button>
      )}
      <Loader loader={isLoader} />
      {value && (
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      )}
    </>
  );
}

export default App;
